import React from 'react'
import Jsonld from '@/modern/components/Seo/Jsonld'
import {
  SCHEMA_CONTEXT,
  SCHEMA_DEFAULT_LANGUAGE,
  WEBMOTORS_ORGANIZATION_ID,
} from '@/modern/components/Seo/schemas/constants'

const WebSiteSchema = () => {
  const schemaTypeId = 'jsonld_website_da'

  const json = {
    '@context': SCHEMA_CONTEXT,
    '@type': 'WebSite',
    name: 'Webmotors',
    url: 'https://www.webmotors.com.br',
    inLanguage: SCHEMA_DEFAULT_LANGUAGE,
    publisher: {
      '@id': WEBMOTORS_ORGANIZATION_ID,
    },
  }

  return <Jsonld id={schemaTypeId} dataQa={schemaTypeId} dataSchema={json} />
}

export default WebSiteSchema
